/**
 * An Immutable is used to make a give types values unchangeable (by reference) and compareable.
 */
export default class Immutable<TYPE> {
	private readonly _value: string;

	/**
	 * Constructs an {@link Immutable} instance
	 */
	constructor(data: TYPE) {
		this._value = JSON.stringify(data);
	}

	/**
	 * Returns the immutable value representation (as json string)
	 */
	public get value(): string {
		return this._value
	}

	/**
	 * Returns the immutable value as original type
	 */
	public get(): TYPE {
		return JSON.parse(this._value);
	}

	/**
	 * Creates an {@link Immutable} from the given data
	 */
	public static from<TYPE>(data: TYPE): Immutable<TYPE> {
		return new Immutable<TYPE>(data);
	}

	/**
	 * Compares two immutables
	 */
	public equals(immutable?: Immutable<TYPE> | null): boolean {
		return this.value === immutable?.value
	}
}